<template>
  <div class="iframe">
    <slot v-if="isInitializedApp" />
  </div>
</template>

<script setup>
import { useStore } from '@/stores/index'

const rootStore = useStore()

const isInitializedApp = ref(false)

// FETCH
try {
  await rootStore.initializeApp()
} catch(err) {
  throw showError({ data: err.data, statusCode: err.statusCode, fatal: true })
} finally {
  isInitializedApp.value = true
}
</script>

<style lang="scss" scoped>
.iframe {
  background: transparent;
  border: none;
  margin: 0;
}
</style>
